import { createOrgV1Mock, OrgType } from '@csp/dmdp-api-org-dto';
import { createMockCreator } from '@csp/test-common-utils';
import { StudyOrgMapper } from '../StudyOrgMapper';

export const treeOrgV1Mock = createOrgV1Mock({
  orgId: '1',
  name: 't1',
  type: OrgType.TREE,
});

export const countryOrgV1Mock = createOrgV1Mock({
  orgId: '2',
  name: 'c2',
  type: OrgType.COUNTRY,
  branchParentIds: ['1'],
  country: {
    countryCode: 'SE',
    langCodes: [],
  },
});

export const practiceOrgV1Mock = createOrgV1Mock({
  orgId: '3',
  name: 'p3',
  type: OrgType.PRACTICE,
  branchParentIds: ['2'],
  practice: {
    practiceType: '',
    addresses: [],
    locations: [],
    practiceCode: '1234',
  },
});

export const createStudyOrgMock = createMockCreator({
  ...StudyOrgMapper.fromOrgV1s([treeOrgV1Mock, countryOrgV1Mock, practiceOrgV1Mock]),
});
